import React, { useMemo, useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { useSelector, useDispatch } from 'react-redux';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { CedAsigequipo } from '../../redux/actions';
import './Grafico.css'; // Import the CSS file

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const Grafico = () => {
  const dispatch = useDispatch();
  const asigusuario = useSelector((state) => state.asigusuario); // Ajusta esto según tu estado
  const usuario = useSelector(state => state.usuario);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

  useEffect(() => {
    dispatch(CedAsigequipo(usuario.usuario.cedula));
  }, [dispatch]);

  const handleMonthChange = (event) => {
    setSelectedMonth(parseInt(event.target.value, 10));
  };

  // Array con los nombres de los meses
  const monthNames = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  const currentMonth = new Date().getMonth() + 1;
  const months = monthNames.slice(0, currentMonth); // Crear un array con los meses hasta el mes actual

  // Procesar los datos para contar tickets por fecha
  const ticketCounts = useMemo(() => {
    const counts = {};

    asigusuario.forEach(asignacion => {
      asignacion.tickets.forEach(ticket => {
        const date = ticket.ticket.fecha.split('T')[0]; // Obtener la fecha sin la hora
        const month = parseInt(date.split('-')[1], 10);
        if (month === selectedMonth) {
          if (!counts[date]) {
            counts[date] = 0;
          }
          counts[date]++;
        }
      });
    });

    return counts;
  }, [asigusuario, selectedMonth]);

  // Preparar los datos para el gráfico
  const labels = Object.keys(ticketCounts);
  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Tickets por fecha',
        data: labels.map(label => ticketCounts[label]),
        backgroundColor: 'rgba(59, 130, 246, 0.7)',
        borderColor: 'rgb(59, 130, 246)',
        borderRadius: 8,
        borderWidth: 0,
        datalabels: {
          anchor: 'end',
          align: 'top',
          formatter: (value) => value,
          font: {
            weight: 'bold',
            family: 'Outfit'
          },
          color: '#1e293b'
        }
      },
    ],
  };

  // Configurar opciones del gráfico
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        backgroundColor: '#1e293b',
        padding: 12,
        titleFont: { size: 14, weight: 'bold', family: 'Outfit' },
        bodyFont: { size: 13, family: 'Outfit' },
        cornerRadius: 8,
      },
      datalabels: {
        display: true,
        anchor: 'end',
        align: 'top',
        formatter: (value) => value,
        font: {
          weight: '600',
          family: 'Outfit'
        },
        color: '#64748b'
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
        },
        ticks: {
          font: { family: 'Outfit', size: 12 }
        }
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: { family: 'Outfit', size: 11 }
        }
      }
    },
  };

  return (
    <div className="grafico-container">
      <div className="month-selector">
        <label htmlFor="month"></label>
        <select id="month" value={selectedMonth} onChange={handleMonthChange}>
          {months.map((month, index) => (
            <option key={index} value={index + 1}>{month}</option>
          ))}
        </select>
      </div>
      <div className="chart-container">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default Grafico;
